import { get, post } from '@api/request';

export async function fetchPINRetrievalRequests(
  { appraisalService },
  authenticationToken,
  { page = 1, pageSize = 200 },
) {
  const url = `${appraisalService}/prodigyappraisalnotices/pinretrievalrequestsruns?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPINRetrievalRequestDetails(
  { appraisalService },
  authenticationToken,
  { page = 1, pageSize = 200, runID, filter },
) {
  const url = `${appraisalService}/prodigyappraisalnotices/pinretrievalrequestsrun/${runID}/details?page=${page}&pageSize=${pageSize}&filter=${filter}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createNewPINRetrievalRequests(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/prodigyappraisalnotices/pinretrievalrequestsruns`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function fetchPendingRetrievalRequests(
  { appraisalService },
  authenticationToken,
  { page = 1, pageSize = 200 },
) {
  const url = `${appraisalService}/prodigyappraisalnotices/pinretrievalrequest/pending/records?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPendingRetrievalRequestsCount(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/prodigyappraisalnotices/pinretrievalrequest/pending`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPinRetrievalRequestConfiguration(
  {appraisalService},
  authenticationToken,
) {
  const url = `${appraisalService}/prodigyappraisalnotices/pinretrievalrequest/configuration`
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updatePinRetrievalRequestConfiguration(
  {appraisalService},
  authenticationToken,
  { payload },
) {
  const url = `${appraisalService}/prodigyappraisalnotices/pinretrievalrequest/configuration`
  const { body } = await post(authenticationToken, url, payload);
  return body;
}
